import { JobOfferRequiredExperience, JobOfferSort, JobOfferType } from '~/constants/jobOffer';

export const formOptions = {
  sort: Object.values(JobOfferSort),
  type: [JobOfferType.PERMANENT, JobOfferType.CONTRACT, JobOfferType.TEMPORARY],
  experience: Object.values(JobOfferRequiredExperience),
} as const;
